var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"radio"},[_c('input',{attrs:{"type":"radio"},domProps:{"checked":_vm.shouldBeChecked,"value":_vm.value},on:{"change":_vm.updateInput}}),_c('div',{staticClass:"radio__dummy"},[(_vm.shouldBeChecked)?_c('base-material-design-icon',{attrs:{"icon":"check"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }